import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStateAnnotating = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("line", {
			x1: 7,
			y1: 5,
			x2: 17,
			y2: 5,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 7,
			y1: 19,
			x2: 17,
			y2: 19,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 19,
			y1: 7,
			x2: 19,
			y2: 17,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 5,
			y1: 7,
			x2: 5,
			y2: 17,
			stroke: "currentColor",
			strokeWidth: 2,
			strokeDasharray: "2 2"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 3,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17,
			y: 17,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 17,
			width: 4,
			height: 4,
			rx: 1,
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgStateAnnotating);
export { ForwardRef as ReactComponent };
